/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from "react";
import PropTypes from "prop-types";
import StandardModal from "js/components/shared/StandardModal";
import { ChakraFAIcon } from "@/components/ui/Icon";

const DeleteAllRulesModal = ({ open, onActions, onClose, rulesCount }) => (
	<StandardModal
		size="small"
		header={<div className="DeleteAllRulesModal_Title">Delete all {rulesCount} rule(s)?</div>}
		open={open}
		actions={onActions}
		close={onClose}
	>
		<div className="DeleteAllRulesModal_Confirm">Are you sure you wish to proceed?</div>
		<div className="DeleteAllRulesModal_Warning">
			<div className="DeleteAllRulesModal_WarningText">
				<ChakraFAIcon icon="fa-exclamation-triangle" variant="solid" className="DeleteAllRulesModal_WarningIcon" />
				This is a permanent action
			</div>
			<div className="DeleteAllRulesModal_WarningSubtext">
				If you share this class with other teachers,
				<br />
				these rules will be deleted for everyone.
			</div>
		</div>
	</StandardModal>
);

DeleteAllRulesModal.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	rulesCount: PropTypes.number,
	onDelete: PropTypes.func,
	onActions: PropTypes.object,
};

export default DeleteAllRulesModal;
